import classNames from "classnames";
import {InertiaLink} from "@inertiajs/inertia-react";

export default function TabBar({ tabs }) {
    // tabs = tabs.map((tab) => {
    //     return {
    //         ...tab,
    //         current: route().current()?.includes(tab.name),
    //     }
    // });

    return (
        <div className="px-4 sm:px-6 lg:px-0 mb-6">
            <div className="lg:hidden">
                <label htmlFor="selected-tab" className="sr-only">
                    Select a tab
                </label>
                <select
                    id="selected-tab"
                    name="selected-tab"
                    className="mt-1 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-purple-500 sm:text-sm sm:leading-6"
                    defaultValue={tabs.find((tab) => tab.current).name}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.label}</option>
                    ))}
                </select>
            </div>
            <div className="hidden lg:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8">
                        {tabs.map((tab) => (
                            <InertiaLink
                                key={tab.name}
                                href={route(tab.name)}
                                className={classNames(
                                    tab.current
                                        ? 'border-purple-500 text-purple-600'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium no-underline'
                                )}
                            >
                                {tab.label}
                            </InertiaLink>
                        ))}
                    </nav>
                </div>
            </div>
        </div>
    )
}
